export const states = {
  default: 'default',
  error: 'error',
  disabled: 'disabled',
};
